import { GetComponentListVariables } from '../graphql/index_types.2';
import { groupComponents, mergePages, normalizeComponent } from '../utils/component';
import { useGetComponentListInfiniteQuery } from './queries/useGetComponentListInfiniteQuery';

export function useComponentList(params: GetComponentListVariables) {
  const {
    data,
    error,
    isFetching: is_fetching,
    fetchNextPage,
    hasNextPage: has_next_page,
    refetch,
  } = useGetComponentListInfiniteQuery(params);
  const component_list = mergePages(data?.pages ?? []).map((component) => normalizeComponent(component));
  const component_map = groupComponents(component_list);
  const category_list = data?.pages[0].category_list ?? [];

  return {
    error,
    is_fetching,
    fetchNextPage,
    has_next_page,
    components: component_map,
    category_list,
    component_list,
    refetch,
  };
}
